// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1-0gx","title":"InfoRow_title__338bo"};